export default __webpack_public_path__ + "static/media/wax_white_SVG.0b216104.svg";